import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgTickBigWarningInfo({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 174 88"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g fill="none" fillRule="evenodd">
        <circle fill="#E7F4FE" cx={87} cy={44} r={44} />
        <path
          d="M87 36.5a5 5 0 015 5l.02 21.03H92a5 5 0 11-9.98-.67L82 41.5v-.22a5 5 0 015-4.78zm0-16a6 6 0 110 12 6 6 0 010-12z"
          fill="#0C8BE6"
        />
        <path
          d="M23.96 21.26c-8.61 15.08-8.61 30.4 0 45.48a3.5 3.5 0 006.08-3.48c-7.39-12.92-7.39-25.6 0-38.52a3.5 3.5 0 00-6.08-3.48z"
          fill="#E7F4FE"
          opacity={0.48}
        />
        <path
          d="M2.21 31.8a34.75 34.75 0 000 24.4 3.5 3.5 0 106.58-2.4 27.75 27.75 0 010-19.6 3.5 3.5 0 00-6.58-2.4z"
          fill="#E7F4FE"
          opacity={0.4}
        />
        <path
          d="M150.04 21.26c8.61 15.08 8.61 30.4 0 45.48a3.5 3.5 0 11-6.08-3.48c7.39-12.92 7.39-25.6 0-38.52a3.5 3.5 0 016.08-3.48z"
          fill="#E7F4FE"
          opacity={0.48}
        />
        <path
          d="M171.79 31.8a34.75 34.75 0 010 24.4 3.5 3.5 0 11-6.58-2.4 27.75 27.75 0 000-19.6 3.5 3.5 0 116.58-2.4z"
          fill="#E7F4FE"
          opacity={0.4}
        />
      </g>
    </svg>
  );
}

SvgTickBigWarningInfo.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgTickBigWarningInfo.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgTickBigWarningInfo svgRef={ref} {...props} />
));
export default ForwardRef;
